<template>
  <button type="button" name="button" @click="$emit('onClick')" :style="{ maxWidth: maxWidth + 'px' }"
    :class="{
      'btn_delete': type == 'delete',
      'btn_blue': type == 'blue',
      'btn_yellow': type == 'yellow',
      'btn_disabled': type == 'disabled',
      'unselected': type == 'unselected'
    }"
    class="btn"
  >
    {{ btnText }}
  </button>
</template>

<script>
export default {
  props: ['btnText', 'type', 'maxWidth'],
  data() {
    return {

    }
  },
}
</script>

<style lang="css" scoped>
.btn {
  width: 100%;
}
.unselected {
  background-color: rgba(0, 0, 0, .1);
  border: 1px solid #fff;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/BaseBtn.vue